
import Vue from 'vue'
import {mapGetters, mapState} from 'vuex';
import MenuComponent from "../components/menucomponent.vue";
import Button from "../components/button.vue";


export default Vue.extend({
  name: 'componentEdit',
  props: {
    msg: String
  },
  components: {
    "pd-menucomponent": MenuComponent,
    "pd-button": Button
  },
  computed: {
    ...mapState("componentEditStore", [
      "activeComponent"
    ]),
    ...mapGetters('componentEditStore', [
      "existingStructure",
      "showEditFrame",
      "selectablePersons",
      "componentTypes",
      "accessPersons",
      "allPersons",
      "activeComponentId",
      "moveComponentMode"
    ])
  },
  data: function (): {
    searchText: string,
    foundPersons: any[]
  } {
    return {
      searchText: "",
      foundPersons: []
    }
  },
  methods: {
    clearSearch: function () {
      this.searchText = "";
      this.searchUser();
    },
    searchUser: function () {
      console.log("suche: " + this.searchText);
      this.foundPersons.splice(0);
      if (this.searchText) {
        const toSearch = this.searchText.toLowerCase();
        for (let aPerson of this.allPersons) {
          if (
              aPerson.companyName.toLowerCase().includes(toSearch) ||
              aPerson.fullName.toLowerCase().includes(toSearch) ||
              aPerson.login.toLowerCase().includes(toSearch)
          ) {
            this.foundPersons.push(aPerson);
          }
        }

      }
      this.foundPersons.sort((o1: any, o2: any) => {
        if (o1.companyName < o2.companyName)
          return -1;
        if (o1.companyName > o2.companyName)
          return 1;

        if (o1.fullName < o2.fullName)
          return -1;
        if (o1.fullName > o2.fullName)
          return 1;

        if (o1.login < o2.login)
          return -1;
        if (o1.login > o2.login)
          return 1;

        return 0;
      });
      return false;
    },
    saveComponent: function () {
      this.$store.commit('componentEditStore/saveComponent');
    },
    startMoveComponent: function () {
      this.$store.commit('componentEditStore/startMoveComponent');
    },
    setEditFrameVisible: function (id: number,otherId:number) {
      this.$store.commit('componentEditStore/editComponent', {componentId:id,projectId:otherId});
    },
    setActiveSupplier: function (supplierId: string) {
      this.$store.commit('componentEditStore/setActiveSupplier', supplierId);
    },
    setActiveContact: function (contactId: string) {
      this.$store.commit('componentEditStore/setActiveContractPerson', contactId);
    },
    setActiveComponentType: function (componentTypeId: string) {
      this.$store.commit('componentEditStore/setActiveComponentType', componentTypeId);
    },
    addAccessPerson: function (personId: string) {
      this.$store.commit('componentEditStore/addAccessPerson', personId);
      this.searchUser();
    },
    rmAccessPerson: function (personId: string) {
      this.$store.commit('componentEditStore/removeAccessPerson', personId);
      this.searchUser();
    },
    adjustTextareaHeight() {
      const textareaRefs: any = [this.$refs["firsttext"], this.$refs["secondtext"]];
      for (let textareas of textareaRefs) {
        if (textareas) {
          for (let textarea of textareas) {

            textarea.style.height = "";
            textarea.style.height = textarea.scrollHeight + "px";
          }
        }
      }
    }
  },
  created() {
    this.$store.commit('componentEditStore/loadFromDb');
  }
})
